/*
 * Close versions, one teacher-month's versions dialog: the "Download CSV" columns. Pure. A row per
 * line (component); per version its figure and its change against the version before it.
 */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';

export const cv_csv_name = (table, pay_month, now) =>
  csv_file_name({ page: 'teacher-payments-close-versions', table, period: pay_month, now });

export const versions_csv_columns = (view, teacher_uuid) => [
  { header: 'Teacher UUID', value: () => teacher_uuid },
  { header: 'Line', key: 'label' },
  { header: 'Line key', key: 'key' },
  ...view.columns.flatMap((c) => [
    { header: c.label, value: (l) => c.figures[l.key], kind: 'money' },
    {
      header: `${c.label} change`,
      // null = first version or nothing recorded to compare: left empty, not 0.
      value: (l) => (c.change ? c.change.lines[l.key].diff : null),
      kind: 'money'
    }
  ])
];
